<template>
  <v-col
    v-editable="blok"
    class="column feature"
    align="center"
    cols="12"
    sm="12"
    md="6"
    lg="4"
    xl="4"
  >
    <v-card
      class="pointer"
      color="transparent"
      elevation="0"
      max-width="270"
    >
      <v-img contain height="350" :src="blok.image" />
      <v-list class="pa-0" align="center" justify="center" two-line>
        <v-list-item>
          <v-list-item-content>
            <span class="pl-4">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <span class="secondary--text font-weight-bold display-1">
                      {{ blok.pricebig }}
                      <span class="ml-n2 pl-0 font-weight-regular title">
                        {{ blok.pricebigcent }}
                      </span>
                    </span>
                  </div>
                </template>
                <span>{{ blok.condition }}</span>
              </v-tooltip>
              <span class="pr-4 grey--text font-weight-regular title" style="text-decoration: line-through;">
                {{ blok.pricesmall }}
              </span>
              <span class="ml-n4 pl-0 grey--text font-weight-regular body-2">
                {{ blok.pricesmallcent }}
              </span>
            </span>
            <v-card-text class="black--text font-weight-regular">
              {{ blok.name }}
            </v-card-text>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "Discount",
  props: ["blok"],
  methods: {
    // onClickOutsite() {
    //   window.open(this.blok.link, "_blank");
    // }
  }
};
</script>
<style>
.pointer {
  cursor: pointer;
}
</style>
